import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Insurance tab body (SWOOP-158), rendered inside the vehicle-profile layout at
 * `/vehicles/$vehicleId/overview/insurance`. Permission gating (`vehicles:list`) is inherited from the
 * layout route's `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview/insurance')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-insurance-page')),
  staticData: { titleKey: 'vehicleInsurance' },
});
